import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Badge = styled.span`
  margin-right: 4px;
  border-radius: 2px;
  background: #9a9999;
  color: #fff;
  padding: 2px 4px;
  font-size: 12px;
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
`

export const advertiserTypes = {
  store: 'Butik',
  company: 'Företag',
  broker: 'Mäklare',
}

export const _AdvertiserTypeSymbol = ({ advertiserType }) => {
  const textSymbol = advertiserTypes[advertiserType]

  if (!textSymbol) {
    return null
  }

  return <Badge>{textSymbol}</Badge>
}

_AdvertiserTypeSymbol.propTypes = {
  advertiserType: PropTypes.string,
}

export default _AdvertiserTypeSymbol
